"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLink = void 0;
const useAnchorProps_1 = require("@uxf/core/hooks/useAnchorProps");
const cx_1 = require("@uxf/core/utils/cx");
const react_1 = __importStar(require("react"));
exports.TextLink = (0, react_1.forwardRef)((props, ref) => {
    // eslint-disable-next-line react/destructuring-assignment
    const { className, children, variant, ...restProps } = props;
    const anchorProps = (0, useAnchorProps_1.useAnchorProps)({
        ...restProps,
        className: (0, cx_1.cx)("uxf-text-link", `uxf-text-link--variant-${variant !== null && variant !== void 0 ? variant : "default"}`, className),
    });
    return (react_1.default.createElement("a", { ref: ref, ...anchorProps }, children));
});
exports.TextLink.displayName = "UxfUiTextLink";
